export const ENV = {
  API_BASE_URL: process.env.REACT_APP_API_BASE_URL || 'https://d13e0igke4fcl7.cloudfront.net',
  API_BASE_URL_KB: process.env.REACT_APP_API_BASE_URL_KB || 'https://eyxx3qlosc.execute-api.us-east-1.amazonaws.com',
  API_BASE_URL_KB2: process.env.REACT_APP_API_BASE_URL_KB2 || 'https://ndka5ccd3b.execute-api.us-east-1.amazonaws.com',
  APP_NAME: process.env.REACT_APP_APP_NAME || "AI Accelerator",
};
